import React from "react";
import {InputAdornment, TextField} from "@mui/material";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import {preventDefaultOnDropFiles} from "../helpers/stubFunctions";
import StatusComponent from "./StatusComponent";

interface BaseInputProps {
    id?: string;
    value?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
    editable?: boolean;
    required?: boolean;
    hasError?: boolean;
    type?: "text" | "number";
    status?: StatusUpdateAnswer;
    endAdornment?: React.JSX.Element;
}

export const BaseInput = ({
                              id,
                              value,
                              onChange,
                              onFocus,
                              editable = true,
                              required = false,
                              hasError = false,
                              type = "text",
                              status = StatusUpdateAnswer.NONE,
                              endAdornment
                          }: BaseInputProps) => {

    const formatNumberValue = (input: string): string => {
        let normalized = input.replace(/,/g, ".");
        normalized = normalized.replace(/[^0-9.]/g, "");
        const dotIndex = normalized.indexOf(".");
        if (dotIndex !== -1) {
            normalized =
                normalized.slice(0, dotIndex + 1) +
                normalized.slice(dotIndex + 1).replace(/\./g, "");
        }
        return normalized;
    };

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (type === "number") {
            event.target.value = formatNumberValue(event.target.value);
        }
        onChange(event);
    };

    const renderAdornment = () => {
        return <StatusComponent
                status={status}
                elseComponent={endAdornment}
        />

    }

    return (
            <TextField
                    id={id}
                    value={value}
                    onChange={handleChange}
                    onFocus={onFocus}
                    disabled={!editable}
                    required={required}
                    error={hasError}
                    inputProps={{inputMode: type === "number" ? 'numeric' : "text"}}
                    onDrop={preventDefaultOnDropFiles}
                    InputProps={{
                        endAdornment: (
                                <InputAdornment position="end">
                                    {renderAdornment()}
                                </InputAdornment>
                        ),
                    }}
            />
    );
};